import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router';

import './Registration.css';
import NavBar from '../NavBar';
import Api from '../../lib/Api';
import { useAppSelector } from '../../lib/hooks';


const Registration: React.FC = () => {

    const sessionToken = useAppSelector((state) => state.imparcial.sessionToken);

    const [email, setEmail] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [confirmationCode, setConfirmationCode] = useState('');
    const [codeId, setCodeId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [resendCode, setResendCode] = useState(false);
    const [error, setError] = useState('');
    const [accountConfirmed, setAccountConfirmed] = useState(false);
    const [showCodeResendConfirmation, setShowCodeResendConfirmation] = useState(true);

    const navigate = useNavigate();

    useEffect(() => {
        if (sessionToken != "") {
            navigate("/", { replace: true });
        }
    }, []);

    const validateEmail = (email: string) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');

        if (email == "") {
            setError('Entre un Correo Electrónico.');
            return;
        }

        if (!validateEmail(email)) {
            setError('El Correo Electrónico no es válido.');
            return;
        }

        setIsLoading(true);

        // Simulate API call
        const registerResult = await Api.register(email);
        if(!registerResult.Error) {
            const _codeId = registerResult.Data;
            if(_codeId) {
                setCodeId(_codeId);
                setIsSubmitted(true);
            }
        }
        setIsLoading(false);
    };

    const handleConfirm = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');

        const code = Number.parseInt(confirmationCode);
        if (!code) {
            setError('Entre un código válido.');
            return;
        }

        // Simulate confirmation API call
        setIsLoading(true);
        await Api.confirmAccount(codeId, code);
        setIsLoading(false);
        setCodeId('');
        setConfirmationCode('');
        setAccountConfirmed(true);
    };

    const resendConfirmationCode = async (e: React.FormEvent) => {
        e.preventDefault();
        if (codeId != "") {
            setResendCode(true);
            const codeResult = await Api.resendAccountConfirmationCode(codeId);
            if(!codeResult.Error) {
                const newCodeId = codeResult.Data;
                if(newCodeId) {
                    setCodeId(newCodeId);
                    setShowCodeResendConfirmation(true);
                    setTimeout(() => {
                        setShowCodeResendConfirmation(false);
                    }, 5000);
                }
            }

            setConfirmationCode('');
            setResendCode(false);
        }

    };

    return (
        <>
            <NavBar />
            <div className="form-container">
                <div className="form-item">
                    {!isSubmitted ? (
                        <>
                            <div className="form-item-title">
                                <h2>Reg&iacute;strate</h2>
                            </div>
                            <form onSubmit={async (e) => await handleSubmit(e)} className="form-data-container">
                                <div className="form-data-item">
                                    <label htmlFor="email">Correo Electr&oacute;nico</label>
                                    <input
                                        type="text"
                                        id="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="form-textbox"
                                        placeholder="juandelpueblo@ejemplo.com"
                                    />
                                </div>
                                {error && <div className="form-data-item" style={{ color: 'red' }}>{error}</div>}
                                <div className="form-data-item">
                                    <button
                                        type="submit"
                                        className="form-button"
                                        disabled={isLoading}
                                    >
                                        {isLoading ? (
                                            <div className="spinner"></div>
                                        ) : (
                                            'Registrar'
                                        )}
                                    </button>
                                </div>
                                <div className='form-data-item'>
                                    <p>¿Ya tiene cuenta?</p>
                                    <Link to="/iniciar-sesion">Presione aqu&iacute; para inicar sesi&oacute;n</Link>
                                </div>
                            </form>
                        </>
                    ) : (
                        <>
                            {
                                !accountConfirmed ?
                                    <>
                                        <div className="form-item-title">
                                            <h2>Confirme su Cuenta</h2>
                                        </div>
                                        <form onSubmit={async (e) => await handleConfirm(e)} className="form-data-container">
                                            <div className="form-data-item">
                                                <label htmlFor="confirmation">C&oacute;digo de Confirmaci&oacute;n</label>
                                                <input
                                                    type="text"
                                                    id="confirmation"
                                                    value={confirmationCode}
                                                    onChange={(e) => setConfirmationCode(e.target.value)}
                                                    className="form-textbox"
                                                    placeholder="Entre su código"
                                                    maxLength={6}
                                                />
                                            </div>
                                            <div className="form-data-item">
                                                <a href='#' onClick={async (e) => await resendConfirmationCode(e)}>
                                                    {resendCode ? (
                                                        <div className='spinner'></div>
                                                    ) : (
                                                        'Presione aquí para enviar otro código'
                                                    )}
                                                </a>
                                                {
                                                    showCodeResendConfirmation ? <p>Su nuevo c&oacute;digo ha sido enviado a su correo electr&oacute;nico.</p> : <></>
                                                }
                                            </div>
                                            {error && <div className="form-data-item" style={{ color: 'red' }}>{error}</div>}
                                            <div className="form-data-item">
                                                <button
                                                    type="submit"
                                                    className="form-button"
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? (
                                                        <div className='spinner'></div>
                                                    ) : (
                                                        'Confirmar'
                                                    )}
                                                </button>
                                            </div>
                                        </form>
                                    </> :
                                    <>
                                        <div className='form-item-title'>
                                            <h3>&iexcl;Su cuenta se confirm&oacute; exitosamente!</h3>
                                        </div>
                                        <div className='form-data-container'>
                                            <div className='form-data-item'>
                                                <a href='/'>Presione aqu&iacute; para inicar sesi&oacute;n</a>
                                            </div>
                                        </div>
                                    </>
                            }
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default Registration;
